const portfolio = [
    {
        src:"/hemi-front-page.png",
        alt:"The front page of the HEMI website",
        title:"HEMI",
        description:"Hempinitiaves.org is the front page for HEMI, a non profit dedicated to the industrial application of hemp products. Developed in collaboration with Tom Rankin, the HEMI website is dashing and professional face the organization can use to reach new markets, share information about events, articles, and products, and spread awareness about their cause.",
        stack:["WordPress","Docker"],
        link:"https://hempinitiatives.org/"
    },
    {
        src:"/eagleheightsacademy-front-page.png",
        alt:"The front page of Eagle Heights Academy",
        title:"Eagle Heights Academy",
        description:"Eagleheightsacademy.org was the next step for the growing school. Previously, their school website had been deeply embedded in their church website, creating confusion and difficulty for anyone trying to get information. The new website presented a much more professional and user-friendly experience, while also allowing the business to separate concerns from the church website and streamline incoming customers.",
        stack:["WordPress"],
        link:"https://eagleheightsacademy.org/"
    },
    {
        src:"/theaugury-front-page.png",
        alt:"The front page for The Augury",
        title:"The Augury",
        description:"This project was my first foray into full stack development. Seeking to solve a real-world problem, I created a database to track the lore of my Dungeon and Dragons campaign. I then also built/deployed a server and client so that my players could access the information. The front end was designed with functionality in mind, aesthetics to come later. As it is, it does exactly what it needs to: abstract Create, Read, Update, and Delete functionality to a useable place for my players. This website utilizes basic authentication to prevent web scrapers and trolls from destroying the database. If you wish to check it out, use these credentials: Username: Admin, Password: speak-basket-kisser-artemis",
        stack:["Next.js","Tailwind","Node.js","Express.js"],
        link:"https://theaugury.hammonthomas.com/"
    }
]

/* {
        src:"",
        alt:"",
        title:"",
        description:"",
        stack:[],
        link:""
    },
*/


export default portfolio;
